// extracted by mini-css-extract-plugin
export default {"filtro":"filtro_filtro__Jxfcu","filtros":"filtro_filtros__StxgG","tipo":"filtro_tipo__gxlgL","selecionado":"filtro_selecionado__9u3ZQ"};